import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

import "LIBS/clamp.js";
import "LIBS/readmore.js";


HSN.Widget.BloomReach = function (config) {
    this.application = config.application;
    this.container = $(config.container);
    this.readMoreWidget = null;
    this.products = null;

    this.init();
};

HSN.Widget.BloomReach.prototype = function () {
    function init() {
        var isMobile = this.application.DeviceInformation.IsMobile;

        if (isMobile) {
            this.readMoreWidget = $('.bloomreach-related-products .product-desc', this.container).readmore({
                speed: 100,
                lessLink: '<a class="read-more" href="#">Less <</a>',
                moreLink: '<a class="read-more" href="#">More ></a>',
                startOpen: false
            });
        } else {
            $('.bloomreach-related-products .product-desc a', this.container).each(function () {
                $clamp($(this)[0], { clamp: 4, splitOnChars: [''] });
            });
            $('.bloomreach-related-products .product-name a', this.container).each(function () {
                $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
            });

            this.products = $('.bloomreach-related-products ul li', this.container)
                .on('mouseenter.bloomreach', function () {
                    $(this).find('.quickview-container').show();
                })
                .on('mouseleave.bloomreach', function () {
                    $(this).find('.quickview-container').hide();
                });
        }
    }
    function destroy() {
        this.application = null;
        this.container = null;

        this.products.off('mouseenter.bloomreach mouseleave.bloomreach');
        if (this.readMoreWidget) {
            this.readMoreWidget.destroy();
        }
    }

    return {
        init: init,
        destroy: destroy
    };
}();



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/BloomReach.js